import type { AiCapabilityPage } from "../schema.js";
import { LIVE, ALL_ROLES } from "./_shared.js";

/**
 * `GRP-ACTIVITY` (@UC0216) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/groups/:groupId/activities` (ADR-0009 bất biến 5).
 * US-AIV2-0110 S10 (`@UC0259`): trước trỏ trang chủ nhóm `/groups/:groupId`; nay tab "Hoạt động" — bấm một dòng mở màn chi tiết nơi làm việc này.
 * Cửa mobile trang này chịu trách nhiệm (nhật ký là dòng thời gian dài, đọc bằng mắt trên màn nhanh hơn nghe kể trong chat).
 */
export const GRP_ACTIVITY = {
  id: "GRP-ACTIVITY",
  uc: "@UC0216",
  tier: "redirect",
  status: LIVE,
  roles: ALL_ROLES,
  flags: [],
  slots: [],
  llm: {
    description:
      "ĐỌC LẠI nhật ký những việc ĐÃ xảy ra trong nhóm: ai ghi khoản nào, ai đã duyệt cái gì, vào lúc nào. Câu hỏi dạng 'ai đã làm X' thuộc về đây, KHÔNG phải trang đi LÀM X (hỏi 'ai duyệt khoản chi vừa rồi' là tra nhật ký, không phải đi duyệt chi). Cũng KHÔNG phải hộp thư thông báo gửi riêng cho tôi (đó là NOTIF-INBOX).",
    examples: [
      "nhóm có gì mới",
      "nhom co gi moi",
      "nhật ký hoạt động",
      "nhat ky hoat dong",
      "ai vừa làm gì trong nhóm",
      "hoạt động gần đây",
      // ——— 0105: thêm cho đủ 40 ———
      "xem nhật ký nhóm",
      "xem nhat ky nhom",
      "hôm nay nhóm có việc gì không",
      "hom nay nhom co viec gi khong",
      "lịch sử thao tác trong nhóm",
      "lich su thao tac trong nhom",
      "ai vừa sửa gì trong nhóm vậy",
      "ai vua sua gi trong nhom vay",
      "có gì thay đổi trong nhóm mấy hôm nay",
      "co gi thay doi trong nhom may hom nay",
      "dòng thời gian của nhóm",
      "dong thoi gian cua nhom",
      "xem các việc mới xảy ra",
      "xem cac viec moi xay ra",
      "nhóm vừa có biến động gì",
      "nhom vua co bien dong gi",
      "ai duyệt khoản chi vừa rồi",
      "ai duyet khoan chi vua roi",
      "tình hình nhóm dạo này thế nào",
      "tinh hinh nhom dao nay the nao",
      "nhóm có ai thao tác gì mới không",
      "nhom co ai thao tac gi moi khong",
      "cập nhật mới nhất của nhóm",
      "cap nhat moi nhat cua nhom",
      "coi lại ai làm gì trong tuần",
      "coi lai ai lam gi trong tuan",
      "mở nhật ký hoạt động lớp 3A",
      "mo nhat ky hoat dong lop 3a",
      "xem log nhóm",
      "xem log nhom",
      "nhóm hôm qua có ai ghi gì không",
      "nhom hom qua co ai ghi gi khong",
      "có ai đổi gì trong nhóm không",
      "co ai doi gi trong nhom khong",
    ],
  },
  screen: "/groups/:groupId/activities",
  screenShows: "group_activity_feed",
  endpoints: [
    "GET /groups/{groupId}/activity",
    // QĐ người dùng 12/10/2026 (@UC0034) — NGƯỜI GỬI huỷ yêu cầu chi của mình: bấm dòng "Yêu cầu chi …" ở tab Hoạt động ⇒ màn yêu cầu
    // chi ⇒ "Huỷ yêu cầu". Chat không làm việc này ⇒ trang redirect về đúng tab đó (§4.4).
    "POST /expenses/{expenseId}/cancel",
  ],
  facts: [],
  templates: {
    redirect: "Mình mở màn hình nhóm để bạn xem nhật ký hoạt động nhé.",
  },
  journey: { after: ["READ-FUND-MONEY"] },
  help: { title: "Nhóm có gì mới", tryNow: "nhóm có gì mới" },
} satisfies AiCapabilityPage;
